// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1WXWN","validationTips":"StatementDescriptor_validationTips__3ndG1"};